module.exports = __webpack_public_path__ + "static/img/bg1@3x.e1e1025.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg1@3x.png
// module id = hT38
// module chunks = 1